import { useEffect, useState, useRef, useCallback, useContext, useMemo } from 'react';
import MailInbox from '../MailInbox';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import WhatsApps from '../Whatsapp';
import services from '../../services';
import Header from '../Header';
import { socket } from '../../socket';
import { toast } from 'react-toastify';
import Select from 'react-select';
import TaskData from '../Task/TaskData';
import axios, { all } from 'axios';
import TaskDataUI from '../Task/TaskDataUI';
import DateSidebarModal from '../../common/DateSidebarModal';
import DOMPurify from 'dompurify';
import AddContactModal from './AddContactModal';
import AddGroupModal from './AddGroupModal';
import { MdAdd } from 'react-icons/md';
import { MultiSelect } from 'react-multi-select-component';
import ComposeEmail from '../composeEmail/ComposeEmail';
import { Modal } from 'react-bootstrap';
import { useSelect } from '@material-tailwind/react';
import { useSelector } from 'react-redux';
import { userDataLocal } from '../../utils/LocalSt';
import { useDispatch } from 'react-redux';
import { whatsaapActiveTab } from '../../Redux/slice';
const PdfIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" style={{ marginRight: 8 }}>
        <rect x="2" y="2" width="28" height="28" rx="6" fill="#fff" stroke="#d1d5db" strokeWidth="1.5" />
        <rect x="2" y="12" width="28" height="10" rx="2" fill="#e53935" />
        <text x="16" y="20" textAnchor="middle" fill="#fff" fontWeight="bold" fontSize="10" fontFamily="Arial">
            PDF
        </text>
    </svg>
);

function Whatsapp({ taskDetails }) {
    const location = useLocation();
    const selectedActiveTab = useSelector((state) => state?.redux);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [nationality, setNationality] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [dateOfBirth, setDateOfBirth] = useState('');
    const [preExistingMedicalConditions, setPreExistingMedicalConditions] = useState('');
    const [isWhatsappTask, setIsWhatsappTask] = useState(false);
    const [isEmailappTask, setIsEmailappTask] = useState(false);
    const [selectedTab, setSelectedTab] = useState(
        location?.state?.selectedMail?.taskType === 'Whatsapp' ? 'WHATSAPP' : 'GMAIL',
    );
    const [selectedEmail, setSelectedEmail] = useState({});
    const [dataById, setDataById] = useState({});
    const [profileId, setProfileId] = useState('');
    const [clientId, setClientId] = useState();
    const [chatData, setChatData] = useState([]);
    const [senderBy, setSenderBy] = useState('');
    const [recivedBy, setRecivedBy] = useState('');
    const [taskData, setTaskData] = useState([]);
    const [selectedContactTaskData, setSelectedContactData] = useState([]);
    const [gender, setGender] = useState('');
    const { id } = useParams();
    const [selectedMail, setSelectedMail] = useState(location.state?.selectedMail || null);
    const [selectedtaskID, setSelectedtaskID] = useState(location.state?.taskID || null);
    const deadlineDate = location.state?.deadlineDate;
    const openTaskDataSidebar = location.state?.openTaskDataSidebar || false;
    const [currentTask, setCurrentTask] = useState(location.state?.currentTask || null);

    const taskDataProps = location.state?.taskDataProps || {};
    const board = JSON.parse(localStorage.getItem('board'));
    const boardId = board?.value;

    const [activeTab, setActiveTab] = useState(selectedActiveTab?.whatsappActiveTag || 'contact');
    const exceptThisSymbols = ['e', 'E', '+', '-', '.'];

    const [contacts, setContacts] = useState([]);

    const [selectedContacts, setSelectedContacts] = useState(null);
    const [groupContacts, setGroupContacts] = useState([]);
    const [selectedGroupContacts, setSelectedGroupContacts] = useState([]);
    const [whatsappprofile, setWhatsappProfile] = useState([]);
    const [selectedprofiles, setSelectedProfiles] = useState([]);

    const [showAddContactModal, setShowAddContactModal] = useState(false);
    const [showAddGroupModal, setShowAddGroupModal] = useState(false);
    const [mergedArray, setMergedArray] = useState([]);

    const hasFetchedTaskRef = useRef(false);
    const navigate = useNavigate();
    const senderByRef = useRef(senderBy);
    const recivedByRef = useRef(recivedBy);
    const [sessionId, setSessionId] = useState(null);
    const [shouldAutoScroll, setShouldAutoScroll] = useState(true);
    const chatContainerRef = useRef(null);
    const [isSocketConnected, setIsSocketConnected] = useState(false);
    const reconnectTimeoutRef = useRef(null);
    const apiCallTimeoutRef = useRef(null);
    const lastMessageRef = useRef(null);
    const [sendingMessages, setSendingMessages] = useState(new Set());
    const refreshTimeoutRef = useRef(null);
    const messageRefreshTimeoutRef = useRef(null);
    const [selectedContact, setSelectedContact] = useState(null);
    const [composeStatus, setComposeStatus] = useState(false);
    const [selectedEmailData, setSelectedEmailData] = useState('');
    const isLoadingRef = useRef(false);
    const [loading, setLoading] = useState(false);
    const [selectedImages, setSelectedImages] = useState([]);
    const [allattachmentsPathData, setAllAttachmentPathData] = useState([]);
    const [isAddingContact, setIsAddingContact] = useState(false);

    const [attachmentTab, setAttachmentTab] = useState('ALL');
    const [getemailbyid, setgetEmailData] = useState('');
    const [formattedBody, setFormattedBody] = useState([]);
    const [mailContent, setMailContent] = useState('');
    const [attachmentsPath, setAttachmentPath] = useState([]);
    const [threadData, setThreadData] = useState([]);
    const [currentTaskId, setCurrentTaskId] = useState(currentTask?.id);
    const [boardListId, setBoardListId] = useState();
    const [selectedEmailId, setSelectedEmailId] = useState(null);

    const [groupSenderBy, setGroupSenderBy] = useState(null);
    const [showAttachement, setShowAttachement] = useState(false);
    const [showSender, steShowSender] = useState(false);
    const [showAllAttachment, setShowAllAttachment] = useState([])
    const handleFirstNameChange = (e) => setFirstName(e.target.value);
    const handlegenderChange = (e) => setGender(e.target.value);
    const handleLastNameChange = (e) => setLastName(e.target.value);
    const handleNationalityChange = (e) => setNationality(e.target.value);
    const handleEmailChange = (e) => setEmail(e.target.value);
    const handlePhoneChange = (e) => setPhone(e.target.value);
    const handleDateOfBirthChange = (e) => setDateOfBirth(e.target.value);
    const handlePreExistingMedicalConditionsChange = (e) => setPreExistingMedicalConditions(e.target.value);
    const userDetails = userDataLocal() || {};
    const dispatch = useDispatch();

    const updateTaskMail = async (id, dedlineData) => {
        try {
            const response = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/task/updateTask/${id}`, {
                deadline: dedlineData,
                taskStatus: 'updated',
                title: currentTask?.title,
                gmailMessageId: currentTask?.gmailMessageId,
                userId: currentTask?.userId,
            });
            if (response) {
            }
        } catch (error) {
            console.error('Error updating task:', error);
        }
    };

    const getTaskMail = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/task/getAllTask`);
            if (response) {
            }
        } catch (error) {
            console.error('Error fetching tasks:', error);
        }
    };

    const setTaskDetailModal = (show) => { };

    const addMessageToChat = (newMessage) => {
        setChatData((prevChatData) => {
            let updatedChatData = [...(prevChatData || [])];

            if (newMessage.id && newMessage.clientId) {
                updatedChatData = updatedChatData.map((msg) =>
                    msg.clientId === newMessage.clientId ? newMessage : msg,
                );
            } else {
                const messageExists = updatedChatData.some(
                    (msg) =>
                        (newMessage.id && msg.id === newMessage.id) ||
                        (newMessage.clientId && msg.clientId === newMessage.clientId) ||
                        (msg.message === newMessage.message &&
                            (msg.time || msg.createdAt) === (newMessage.time || newMessage.createdAt)),
                );

                if (!messageExists) {
                    updatedChatData.push(newMessage);
                }
            }

            return updatedChatData.sort((a, b) => {
                const timeA = a.time || new Date(a.createdAt).getTime() || 0;
                const timeB = b.time || new Date(b.createdAt).getTime() || 0;
                return timeA - timeB;
            });
        });
    };

    useEffect(() => {
        const query = new URLSearchParams(location.search);
        const encodedProps = query.get('props');

        if (encodedProps) {
            const decodedProps = decodeURIComponent(encodedProps);
            const parsedProps = JSON.parse(decodedProps);
            linkData(parsedProps?.linkId);
        }
    }, [location.search]);

    const linkData = async (linkId) => {
        try {
            const response = await services.task.GET_TASK_LINK_DATA(linkId);
            const data = response?.data?.data;

            if (data) {
                setSelectedEmail(data?.task);
                setSelectedEmailId(data?.task?.gmailMessageId);
                handlegetEmailDetails(data?.task?.gmailMessageId);
                setCurrentTask(data?.task);
                getTaskById(data?.task?.id);
                setSelectedMail(data?.task);
                handleContactSelect(data?.task?.contactId);
                setSelectedContact(data?.task?.contactId);
                setSelectedtaskID(data?.task?.id);
                setCurrentTaskId(data?.taskId);
                setSele;
            }
        } catch (error) {
            console.error(error, 'error');
        }
    };

    const handleMessageSaved = useCallback((message) => {
        lastMessageRef.current = message;

        setChatData((prevChatData) => {
            const messageExists = prevChatData?.some((msg) => msg.id === message.id);
            if (messageExists) {
                return prevChatData;
            }

            if (message.messageSendBy === senderByRef.current) {
                setSendingMessages((prev) => {
                    const newSet = new Set(prev);
                    newSet.delete(message.id);
                    return newSet;
                });
            } else {
            }

            const updatedChatData = [...(prevChatData || []), message];
            return updatedChatData.sort((a, b) => {
                const timeA = a.time || a.lastSeen || a.createdAt || 0;
                const timeB = b.time || b.lastSeen || b.createdAt || 0;
                return timeA - timeB;
            });
        });

        if (messageRefreshTimeoutRef.current) {
            clearTimeout(messageRefreshTimeoutRef.current);
        }
        messageRefreshTimeoutRef.current = setTimeout(() => {
            getAllTaskContact();

            if (contactIdRef.current) {
                getChatById(contactIdRef.current);
            }
        }, 2000);
    }, []);

    const handleWhatspp = async (message) => {
        if (!selectedContact && !selectedGroupContacts.value) {
            toast.error('Please select a contact or group first!');
            return;
        }

        const timestamp = Math.floor(Date.now() / 1000);
        const tempMessageId = `local-${Date.now()}`;
        const isGroupMessage = !!selectedGroupContacts?.value;
        const baseData = {
            id: tempMessageId,
            message,
            clientId: isGroupMessage ? groupSenderBy?.clientId : clientId,
            time: timestamp,
            type: 'text',
            lastSeen: timestamp,
        };

        if (isGroupMessage) {
            baseData.groupId = selectedGroupContacts?.id || null;
            baseData.isGroup = true;
            baseData.messageSendBy = groupSenderBy?.contact || null;
            baseData.messageRecivedBy = selectedGroupContacts?.id || null;
        } else {
            baseData.messageSendBy = senderBy;
            baseData.messageRecivedBy = recivedBy;
        }

        let captionUsedInImage = false;

        if (selectedImages && selectedImages.length > 0) {
            const formData = new FormData();
            selectedImages.forEach((file) => formData.append('files', file));
            const contactNumber = selectedContact?.contactNo;
            const captionDetails = isGroupMessage ? message : message;
            const to = isGroupMessage ? selectedGroupContacts.value : contactNumber;
            if (!to) {
                toast.error('Contact or group not selected for attachment.');
                return;
            }

            const finalSessionId = isGroupMessage ? sessionId : selectedContact?.Profile?.clientId;
            if (!finalSessionId) {
                toast.error('Session ID not found.');
                return;
            }
            formData.append('sessionId', finalSessionId);
            formData.append('to', to);
            formData.append('caption', captionDetails);
            if (isGroupMessage) {
                formData.append('groupId', baseData?.groupId);
                formData.append('isGroup', baseData?.isGroup);
            }

            try {
                const uploadRes = await services.Whatsapp.ADD_WHATSAAP_ATTACHMENT(formData);
                const uploadedFiles = uploadRes?.data?.files || [];

                uploadedFiles.forEach((file) => {
                    const imageMessage = {
                        id: `img-${Date.now()}`,
                        clientId,
                        time: Math.floor(Date.now() / 1000),
                        type: 'image',
                        imageUrl: file.url,
                        caption: message || '',
                    };

                    if (isGroupMessage) {
                        imageMessage.groupId = selectedGroupContacts.value;
                        imageMessage.isGroup = true;
                    } else {
                        imageMessage.messageSendBy = senderBy;
                        imageMessage.messageRecivedBy = recivedBy;
                    }
                    addMessageToChat(imageMessage);
                });

                captionUsedInImage = !!message?.trim();
            } catch (uploadErr) {
                console.error('Error uploading files:', uploadErr);
                toast.error('Failed to upload images.');
                return;
            } finally {
                setSelectedImages([]);
            }
        }

        if (captionUsedInImage) {
            return;
        }

        if (message?.trim()) {
            setSendingMessages((prev) => new Set(prev).add(tempMessageId));
            addMessageToChat(baseData);
            socket.emit('newMessage', baseData);

            try {
                await services.Whatsapp.WHATS_APP_EMAIL_SEND(baseData);

                setSendingMessages((prev) => {
                    const newSet = new Set(prev);
                    newSet.delete(tempMessageId);
                    return newSet;
                });
                getAllTaskContact();
            } catch (err) {
                console.error(err, 'err');
                toast.error('Failed to send message.');
                setChatData((prevChatData) => prevChatData?.filter((msg) => msg.id !== tempMessageId) || []);
            }
        }
    };

    const handleContactSelect = (contact) => {
        setChatData([]);
        setSendingMessages(new Set());
        if (contact && contact.id) {
            setSelectedGroupContacts({ value: contact.id, label: contact.name, id: contact.contactNo });
            setSelectedContact(null);
            setSelectedContacts(null);
            getChatById(contact.id, true);
            getAllTaskContact();
        } else {
            setSelectedContacts(contact);
            setSelectedGroupContacts([]);
            if (contact && contact.id) {
                getChatById(contact.id, false);
            }
        }
    };

    const getChatById = async (id, isGroup = false) => {
        if (!id) return;
        setLoading(true);
        try {
            const response = await services.Whatsapp.GET_CHAT_BYID_WHATSAPP(id, isGroup);

            if (response?.data?.data) {
                const chatHistory = response.data.data.Chats || [];
                setChatData(chatHistory);

                if (isGroup) {
                    setGroupSenderBy(response.data.data.Profile);
                } else {
                    setRecivedBy(response.data.data.contactNo?.replace(/\\D/g, ''));
                    setSenderBy(response.data.data.Profile?.contact?.replace(/\\D/g, ''));
                    setClientId(response.data.data.Profile?.clientId);
                    setProfileId(response.data.data.contactNo);
                }
            } else {
                setChatData([]);
            }
        } catch (e) {
            console.error('Error fetching chat:', e);
            setChatData([]);
        } finally {
            setLoading(false);
        }
    };

    const handleTabChange = (tab) => {
        setSelectedTab(tab);
        if (tab === 'GMAIL') {
            setSelectedEmail({ email });
        }
    };

    const extractEmailAddress = (emailString) => {
        if (!emailString) return '';
        const match = emailString.match(/<([^>]+)>/);
        if (match) {
            return match[1];
        }
        return emailString;
    };
    const [childTaskData, setChildTask] = useState([]);
    const [getAllChildTask, setGetAllChildTask] = useState([]);

    const [allSelectedEmail, setAllSelectedEmail] = useState(null);
    const getTaskById = async (id) => {
        try {
            const response = await services.Whatsapp.WHATSAPP_GETTASKBYID(id);
            if (response) {
                const taskData = response?.data?.data;
                setDataById(taskData);
                if (taskData?.taskType == 'Gmail') {
                    setEmail(extractEmailAddress(taskData?.Email?.sentTo) || '');
                    setIsEmailappTask(true);
                    setIsWhatsappTask(false);
                    setChildTask(taskData?.childTasks[0]);
                    setGetAllChildTask(taskData?.childTasks);
                }

                hasFetchedTaskRef.current = true;
            }
        } catch (error) {
            console.error('Error fetching task mails:', error);
        }
    };
    const handlegetMessage = async () => {
        try {
            await services.Whatsapp.GET_WHATSAPP_MESSAGE();
        } catch (error) {
            console.error('Error', error);
        }
    };

    const contactIdRef = useRef(null);
    const handleClearState = () => {
        setFirstName('');
        setLastName('');
        setEmail('');
        setGender('');
        setPhone('');
        setNationality('');
        setPreExistingMedicalConditions('');
    };

    const handleSubmitTraveller = async (item, optionselected) => {
        const data = {
            firstName,
            lastName,
            email,
            gender,
            phoneNumber: phone,
            Nationality: nationality,
            medicalConditions: preExistingMedicalConditions,
            taskId: id,
        };

        try {
            const result = await services.Whatsapp.Travel_Contact(data);
            if (result?.status === 201 && item === 'traveller') {
                toast.success(result?.data?.message);
            }

            if (activeTab === 'group') {
                const groupData = {
                    contactId: [optionselected.value],
                    taskId: selectedtaskID,
                };
                await services.task.CREATE_CONTACT_TASK(groupData);
            } else {
                const contactToUse = optionselected || selectedContacts;
                if (contactToUse) {
                    const contactData = {
                        contactId:
                            item === 'contact-change'
                                ? [optionselected?.value]
                                : item === 'contact'
                                    ? [optionselected?.id]
                                    : [optionselected?.value],
                        taskId: selectedtaskID,
                    };
                    await services.task.CREATE_CONTACT_TASK(contactData);
                }
            }

            if (isEmailappTask) {
                getTaskById(id);
                getAllTaskContact();
            } else {
                getAllTaskContact();
                getChatById(id);
            }
        } catch (e) {
            console.error(e);
        }
    };

    const getAllProfileWhatsapp = async () => {
        try {
            const response = await services.Whatsapp.GET_PROFILE_WHATSAPP();

            if (response?.data) {
                const profileOptions = response?.data?.map((profile) => ({
                    value: profile.id,
                    label: profile.name || profile.profile,
                    clientId: profile.clientId,
                }));

                setWhatsappProfile(profileOptions);
                const defaultProfile = profileOptions && profileOptions[0];
                setSessionId(defaultProfile.clientId);
                await handleProfileChange(defaultProfile);
            }
        } catch (err) {
            console.error(err, 'err');
        }
    };

    const getAllTaskContact = async () => {
        try {
            const response = await services.task.GET_TASK_CONTACT_BY_ID(selectedtaskID);

            const data = response?.data?.data[0]?.Contact;

            setTaskData(response?.data?.data);
            setSelectedContactData(response?.data?.data);

            const contactIds = response?.data?.data?.map((item) => item.contactId).filter(Boolean);

            if (!selectedContacts?.value && !isAddingContact) {
                if (data) {
                    const contactObject = {
                        value: data.id,
                        label: data.name || data.contactNo?.split('@')[0] || 'Unknown Contact',
                    };
                } else if (contactIds && contactIds.length > 0 && contacts.length > 0) {
                    const foundContact = contacts.find((contact) => contactIds.includes(contact.value));
                    if (foundContact) {
                    }
                }
            }
            setSelectedContact(response.data.data[0]?.Contact);
            if (response?.data?.data && response.data.data.length > 0 && !selectedContact) {
                const firstContact = response.data.data[0]?.Contact;
                if (firstContact) {
                    setSelectedContact(firstContact);

                    if (firstContact.contactId) {
                        getChatById(firstContact.contactId);
                    }
                }
            }

            setChatData((prevChatData) => {
                const serverChats = data?.Chats || [];
                const localMessages = prevChatData || [];

                const existingMessages = new Map();

                serverChats.forEach((serverMsg) => {
                    const key = serverMsg.id || `${serverMsg.message}-${serverMsg.time}`;
                    if (!existingMessages.has(key)) {
                        existingMessages.set(key, serverMsg);
                    }
                });

                const mergedChats = Array.from(existingMessages.values()).sort((a, b) => {
                    const timeA = a.time || a.lastSeen || a.createdAt || 0;
                    const timeB = b.time || b.lastSeen || b.createdAt || 0;

                    if (timeA === timeB) {
                        return 0;
                    }

                    return timeA - timeB;
                });

                return mergedChats;
            });

            setRecivedBy(data.contactNo?.replace(/\D/g, ''));
            setSenderBy(data.Profile?.contact?.replace(/\D/g, ''));
            setClientId(data.Profile?.clientId);
            setProfileId(data.contactNo);
        } catch (error) {
            console.error('Error fetching contacts:', error);
        }
    };

    const handleContactChange = async (selectedOption) => {
        if (!selectedprofiles || !selectedprofiles.value) {
            toast.error('Please select a profile first!');
            return;
        }
        setSelectedContacts(selectedOption);
        handleSubmitTraveller('contact-change', selectedOption);

        getAllTaskContact();
    };

    const handleProfileChange = async (selectedOptions) => {
        if (selectedOptions?.clientId) {
            setSessionId(selectedOptions.clientId);
        }
        setSelectedProfiles(selectedOptions);
        const id = selectedOptions?.value;
        try {
            const response = await services.Whatsapp.GET_BYID_WHATSAPP_PROFILE(id);
            if (response?.data) {
                const contactOptions = response?.data?.data?.Contacts?.map((contact) => ({
                    value: contact.id,
                    label: contact.name || contact.contactNo,
                }));
                setContacts(contactOptions);

                if (!selectedContacts?.value) {
                }
            }

            const responsegroup = await services.Whatsapp.GET_BY_GROUP_ID_WHATSAPP_PROFILE(id);

            if (responsegroup?.data) {
                const groupOptions = responsegroup?.data?.data?.Contacts?.map((group) => ({
                    value: group.id,
                    label: group.name,
                    id: group?.contactNo,
                }));
                setGroupContacts(groupOptions);
            }
        } catch (err) {
            console.error(err, 'err');
        }
    };
    const handleGroupContactChange = async (selectedOption) => {
        if (!selectedprofiles || !selectedprofiles.value) {
            toast.error('Please select a profile first!');
            return;
        }
        const groupAsContact = {
            id: selectedOption.value,
            name: selectedOption.label,
            contactNo: selectedOption.id,
        };

        handleContactSelect(groupAsContact);

        handleSubmitTraveller('contact-change', selectedOption);
    };

    const handleContactAdded = async (newContact) => {
        try {
            setIsAddingContact(true);
            if (selectedprofiles?.value) {
                let matchedContact = null;
                let attempts = 0;
                while (!matchedContact && attempts < 5) {
                    const response = await services.Whatsapp.GET_BYID_WHATSAPP_PROFILE(selectedprofiles?.value);
                    const allFreshContacts = response?.data?.data?.Contacts || [];

                    const contactOptions = allFreshContacts.map((contact) => ({
                        value: contact.id,
                        label: contact.name || contact.contactNo,
                    }));
                    setContacts(contactOptions);

                    matchedContact = allFreshContacts.find((item) => item?.contactNo?.includes(newContact.value));

                    if (matchedContact) {
                        setSelectedContacts({
                            value: matchedContact.id,
                            label: matchedContact.name || matchedContact.contactNo,
                        });
                        setSelectedContact(matchedContact);

                        await handleSubmitTraveller('contact', matchedContact);

                        await getChatById(matchedContact.id);

                        break;
                    }

                    attempts++;
                    await new Promise((resolve) => setTimeout(resolve, 1000));
                }

                if (!matchedContact) {
                }

                await getAllTaskContact();
            }
        } catch (error) {
            console.error('Error handling contact addition:', error);
            toast.error('Failed to add contact to selection. Please try again.');
        } finally {
            setIsAddingContact(false);
        }
    };

    useEffect(() => {
        if (selectedContact && contacts.length > 0) {
            const stillExists = contacts.find((c) => c.value === selectedContact.id);
            if (stillExists) {
                setSelectedContacts(stillExists);
            }
        }
    }, [selectedContact, contacts]);
    const handleGroupAdded = async (newGroup) => {
        try {
            if (selectedprofiles?.value) {
                const response = await services.Whatsapp.GET_BY_GROUP_ID_WHATSAPP_PROFILE(selectedprofiles.value);
                if (response?.data) {
                    const groupOptions = response?.data?.data?.Contacts?.map((group) => ({
                        value: group.id,
                        label: group.name,
                    }));
                    setGroupContacts(groupOptions);

                    setSelectedGroupContacts(newGroup);

                    toast.success(`Group "${newGroup.label}" has been selected!`);
                }
            }
        } catch (error) {
            console.error('Error refreshing groups:', error);
        }
    };

    const decodeHtml = (html) => {
        const txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    };

    const handlegetEmailDetails = async (id) => {
        if (!id) return;
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/email/getEmailBy/${id}`);
            setgetEmailData(response?.data);
            setSelectedEmail(response?.data);
            setThreadData(response?.data?.SubEmails);

            if (response?.data?.SubEmails || response?.data) {
                const sanitizedEmails = response.data.SubEmails;
                const mainAttachments = response?.data?.attachmentPaths || [];
                const subEmailAttachments = (response?.data?.SubEmails || []).flatMap(
                    (sub) => sub.attachmentPaths || [],
                );

                const mergedAttachments = [...mainAttachments, ...subEmailAttachments];

                setMergedArray(mergedAttachments);

                setFormattedBody(sanitizedEmails);
                setAttachmentPath(response?.data);
            }

            const decodedHtml = decodeHtml(response?.data?.body);
            const cleanHtml = DOMPurify.sanitize(decodedHtml);
            setMailContent({ ...response?.data, body: cleanHtml });
            setTimeout(() => {
                setLoading(false);
            }, 2000);
        } catch (error) { }
    };

    const [allEmailAttachments, setAllEmailAttachments] = useState([]);
    const getAllAttachmentData = async (id) => {
        try {
            const response = await services.Whatsapp.GET_ALL_ATTACHMENT(id);
            const responseData = response?.data?.data;

            const emailPaths = (responseData?.emailAttachments || []).flatMap((item) => item?.attachmentPaths || []);
            const subEmailPaths = (responseData?.subEmailAttachments || []).flatMap(
                (item) => item?.attachmentPaths || [],
            );

            const whatsappPaths = (chatData || []).flatMap((item) => item?.attachementPath || []);

            const allPaths = [...emailPaths, ...subEmailPaths, ...whatsappPaths];

            setAllEmailAttachments(emailPaths);

            setAllAttachmentPathData(allPaths);

            return response;
        } catch (error) {
            console.error('Error fetching attachment data:', error);
            return null;
        }
    };

    useEffect(() => {
        getAllProfileWhatsapp();
    }, []);

    useEffect(() => {
        handlegetMessage();
        getAllTaskContact();

        return () => {
            if (refreshTimeoutRef.current) {
                clearTimeout(refreshTimeoutRef.current);
            }
        };
    }, []);

    const fetchData = async (taskId) => {
        try {
            let queryString = '';
            if (isEmailappTask) {
                queryString = `email=${email}`;
            }
            if (isWhatsappTask) {
                const phoneNumber = String(phone).replace(/\D/g, '');
                queryString = `phone=${phoneNumber}`;
            }

            const response = await services.task.GET_TRAVEL_BY_TASK(taskId, queryString);
            const travelDetails = response?.data?.data;

            setEmail(travelDetails?.email);
            setPhone(travelDetails?.phoneNumber);
            setFirstName(travelDetails?.firstName);
            setLastName(travelDetails?.lastName);
            setNationality(travelDetails?.Nationality);
            setPreExistingMedicalConditions(travelDetails?.medicalConditions);
        } catch (error) {
            console.error('Error fetching task mails:', error);
        }
    };

    useEffect(() => {
        if (selectedtaskID) {
            fetchData(selectedtaskID);
        }
    }, [selectedtaskID, isEmailappTask, isWhatsappTask]);
    useEffect(() => {
        const setSelectedContactsFromTask = async () => {
            if (selectedtaskID && whatsappprofile.length > 0) {
                try {
                    const response = await services.task.GET_TASK_CONTACT_BY_ID(selectedtaskID);
                    const contactIds = response?.data?.data?.map((item) => item.contactId).filter(Boolean);

                    const data = response?.data?.data[0]?.Contact;

                    if (data?.Profile && whatsappprofile.length > 0) {
                        const profileOption = whatsappprofile.find((profile) => profile.value === data.Profile.id);

                        if (profileOption && !selectedprofiles?.value) {
                            setSelectedProfiles(profileOption);
                        }
                    }

                    if (selectedActiveTab?.whatsappActiveTag == 'contact') {
                        const contactObject = {
                            value: data.id,
                            label: data.name || data.contactNo?.split('@')[0] || 'Unknown Contact',
                        };
                    } else {
                        const selectedGroupOption = groupContacts.find((group) => group?.value);
                    }
                } catch (error) {
                    console.error('Error fetching task contacts for selection:', error);
                }
            }
        };

        setSelectedContactsFromTask();
    }, [
        selectedtaskID,
        whatsappprofile,
        contacts,
        groupContacts,
        selectedprofiles?.value,
        selectedContacts?.value,
        activeTab,
    ]);

    const selectedUserId = useMemo(() => {
        return childTaskData?.Email?.gmailMessageId
            ? childTaskData.Email.gmailMessageId
            : selectedEmail?.gmailMessageId || selectedEmailData;
    }, [childTaskData, selectedEmail, selectedEmailData]);

    useEffect(() => {
        if (selectedUserId) {
            handlegetEmailDetails(selectedUserId);
        }
    }, [selectedUserId]);
    useEffect(() => {
        if (attachmentTab) {
            getAllAttachmentData(id);
        }
    }, [attachmentTab, selectedTab]);

    useEffect(() => {
        if (selectedTab === 'GMAIL') {
            setSelectedEmail(selectedMail || {});
        }
    }, [selectedTab, selectedMail]);

    useEffect(() => {
        if (!chatContainerRef.current) return;
        const chatContainer = chatContainerRef.current;

        const scrollToBottom = () => {
            chatContainer.scrollTo({
                top: chatContainer.scrollHeight,
                behavior: 'smooth',
            });
        };

        const isNearBottom = chatContainer.scrollHeight - chatContainer.scrollTop - chatContainer.clientHeight < 100;

        if (isNearBottom || shouldAutoScroll || chatContainer.scrollTop === 0) {
            const imgs = chatContainer.querySelectorAll('img');
            let pending = imgs.length;

            if (pending === 0) {
                scrollToBottom();
            } else {
                let loadedCount = 0;
                imgs.forEach((img) => {
                    if (img.complete) {
                        loadedCount++;
                        if (loadedCount === pending) scrollToBottom();
                    } else {
                        img.addEventListener(
                            'load',
                            () => {
                                loadedCount++;
                                if (loadedCount === pending) scrollToBottom();
                            },
                            { once: true },
                        );
                    }
                });
            }
        }
    }, [chatData, shouldAutoScroll, selectedTab]);

    useEffect(() => {
        const connectSocket = () => {
            if (socket.connected) {
                socket.disconnect();
            }

            socket.connect();

            socket.on('connect', () => {
                setIsSocketConnected(true);
                getChatById(contactIdRef.current);
                getAllTaskContact();
            });

            socket.on('disconnect', () => {
                setIsSocketConnected(false);

                setTimeout(() => {
                    if (!socket.connected) {
                        socket.connect();
                    }
                });
            });

            socket.on('connect_error', (error) => {
                console.error('Socket connection error:', error);
                setIsSocketConnected(false);
            });

            socket.on('newMessage', handleMessageSaved);
        };

        connectSocket();

        return () => {
            socket.off('newMessage', handleMessageSaved);
            socket.off('messageSent');
            socket.off('messageError');
            socket.disconnect();
        };
    }, [handleMessageSaved]);

    useEffect(() => {
        if (selectedtaskID && !hasFetchedTaskRef.current) {
            getTaskById(selectedtaskID);
        }
    }, [selectedtaskID]);
    const [selectedDescription, setSelectedDescription] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [notes, setNotes] = useState([
        {
            id: Date.now(),
            title: '',
            description: '',
            doesMatchSearch: true,
        },
    ]);
    const [searchText, setSearchText] = useState('');

    const [newTitle, setNewTitle] = useState('');
    const [newDescription, setNewDescription] = useState('');

    useEffect(() => {
        const stringifiedNotes = localStorage.getItem('savedNotes');
        if (stringifiedNotes) {
            const savedNotes = JSON.parse(stringifiedNotes);
            setNotes(savedNotes);
        }
    }, []);

    useEffect(() => {
        localStorage.setItem('savedNotes', JSON.stringify(notes));
    }, [notes]);

    const handleAddNote = async () => {
        if (!newTitle && !newDescription) return;

        const object = {
            taskId: id,
            notes: newTitle,
            description: newDescription,
            userId: userDetails?.id,
        };

        const response = await services.internalnotes.CREATE_INTERNAL_NOTES(object);
        if (response?.status == 201) {
            toast.success(response?.data?.message);
            getAllInternalNotes(id);
        }

        setNewTitle('');
        setNewDescription('');
    };

    const deleteNote = async (noteId) => {
        const response = await services.internalnotes.DELETE_INTERNAL_NOTES(noteId);
        if (response?.status == 200) {
            toast?.success(response?.data?.message);
            getAllInternalNotes(noteId);
        }
    };
    const getAllInternalNotes = async (id) => {
        try {
            const response = await services.internalnotes.GET_INTERNAL_NOTES(id);
            setNotes(response?.data?.data);
        } catch (err) {
            console.error(err, 'err');
        }
    };
    useEffect(() => {
        getAllInternalNotes(id);
        getSingleTask(id)
    }, [id, selectedTab, attachmentTab]);

    const handleDescriptionClick = (description) => {
        setSelectedDescription(description);
        setShowModal(true);
    };

    const [originalEmail, setOriginalEmail] = useState(null);
    const [threadMergedArray, setthreadMergedArray] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);

    useEffect(() => {
        if (getemailbyid && !originalEmail) {
            setOriginalEmail(getemailbyid);
        }
    }, [getemailbyid]);

    useEffect(() => {
        const subTasks = Array.isArray(getAllChildTask) ? getAllChildTask : [];
        let merged = subTasks;

        if (originalEmail) {
            const index = subTasks.findIndex((item) => item?.Email?.id === originalEmail.id);
            if (index > -1) {
                merged = [subTasks[index], ...subTasks.slice(0, index), ...subTasks.slice(index + 1)];
            } else {
                merged = [originalEmail, ...subTasks];
            }
            setSelectedItem((prev) => prev || merged[0]);
        }
        const uniqueMerged = merged.filter((item, idx, arr) => arr.findIndex((i) => i.id === item.id) === idx);

        if (uniqueMerged.length > 0) {
            setthreadMergedArray(uniqueMerged);
            setSelectedItem((prev) => prev || uniqueMerged[0]);
        }
    }, [selectedMail, originalEmail, getAllChildTask]);

    useEffect(() => {
        handlegetEmailDetails(selectedItem?.gmailMessageId);
    }, [selectedItem]);



    const getSingleTask = async (taskId) => {
        if (!taskId) return;

        try {
            const response = await services.task.GET_TASK_BY_ID(taskId);
            const singleTaskDetails = response?.data?.data;
            setShowAllAttachment(singleTaskDetails?.attachment)

        } catch (error) {
            console.error('Error fetching task data:', error);
        }
    };


    return (
        <div className="flex w-full max-h-[100vh]   " style={{ scrollbarWidth: 'none' }}>
            <div className="w-[75%] max-w-[75%] ">
                <div className="flex text-[1.2vw] w-full items-center w-full mb-2 tap-button-o">
                    <button className="flex items-center px-3 gap-2" onClick={() => navigate('/kanban')}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="lucide lucide-arrow-left"
                        >
                            <path d="M19 12H5M12 19l-7-7 7-7" />
                        </svg>
                    </button>
                    <button
                        className={` flex-1 py-2   rounded-l-[4px] ${selectedTab === 'GMAIL'
                            ? ' text-white border-l border-y border-[#2d6ec7] bg-[#2d6ec7]'
                            : 'text-[#2d6ec7] border-y border-l  border-[#2d6ec7]'
                            }`}
                        onClick={() => handleTabChange('GMAIL')}
                    >
                        GMAIL
                    </button>
                    <button
                        className={`flex-1 py-2  ${selectedTab === 'WHATSAPP'
                            ? ' text-white border border-[rgb(45,110,199)] bg-[#2d6ec7]'
                            : 'text-[#2d6ec7] border-y   border-[#2d6ec7]'
                            }`}
                        onClick={() => handleTabChange('WHATSAPP')}
                    >
                        WHATSAPP
                        {selectedTab === 'WHATSAPP' && (
                            <span
                                className={`ml-2 inline-block w-2 h-2 rounded-full ${isSocketConnected ? 'bg-green-500' : 'bg-red-500'
                                    }`}
                                title={isSocketConnected ? 'Socket Connected' : 'Socket Disconnected'}
                            ></span>
                        )}
                    </button>
                    <button
                        className={`flex-1 py-2  ${selectedTab === 'INTERNAL NOTES'
                            ? ' text-white border border-[#2d6ec7] bg-[#2d6ec7]'
                            : 'text-[#2d6ec7] border-y   border-[#2d6ec7]'
                            }`}
                        onClick={() => handleTabChange('INTERNAL NOTES')}
                    >
                        INTERNAL NOTES
                    </button>
                    <button
                        className={`flex-1 py-2  ${selectedTab === 'All'
                            ? ' text-white border border-[#2d6ec7] bg-[#2d6ec7]'
                            : 'text-[#2d6ec7] border-y  border-[#2d6ec7]'
                            } py-2 `}
                        onClick={() => handleTabChange('All')}
                    >
                        All
                    </button>
                    <button
                        className={`flex-1 py-2  ${selectedTab === 'SENDER DETAILS'
                            ? ' text-white border border-[#2d6ec7] bg-[#2d6ec7]'
                            : 'text-[#2d6ec7] border-y  border-[#2d6ec7]'
                            } py-2 `}
                        onClick={() => handleTabChange('SENDER DETAILS')}
                    >
                        SENDER DETAILS
                    </button>

                    <button
                        className={` flex-1 rounded-r-[4px]  ${selectedTab === 'ATTACHEMENT'
                            ? ' text-white border border-[#2d6ec7] bg-[#2d6ec7]'
                            : 'text-[#2d6ec7] border-y border-r border-[#2d6ec7]'
                            } py-2  `}
                        onClick={() => handleTabChange('ATTACHEMENT')}
                    >
                        ATTACHEMENT
                    </button>
                </div>
                <div className="">
                    {selectedTab === 'GMAIL' && (
                        <div className="  ">
                            <MailInbox
                                selectedEmailData={selectedEmail}
                                deadlineDate={deadlineDate}
                                dataById={dataById}
                                taskDetails={taskDetails}
                                setgetEmailData={setgetEmailData}
                                getemailbyid={getemailbyid}
                                threadData={threadData}
                                formattedBody={formattedBody}
                                setFormattedBody={setFormattedBody}
                                mailContent={mailContent}
                                setMailContent={setMailContent}
                                handlegetEmailDetails={handlegetEmailDetails}
                                attachmentPaths={attachmentsPath}
                                decodeHtml={decodeHtml}
                                setSelectedEmailData={setSelectedEmailData}
                                selectedEmailId={selectedEmailData}
                                setCurrentTask={setCurrentTask}
                                selectedMail={selectedEmail}
                                loading={loading}
                                setLoading={setLoading}
                                childTaskData={childTaskData}
                                TaskId={id}
                            // selectedEmail={selectedEmail}
                            />
                            {composeStatus && (
                                <>
                                    {selectedMail?.boardId ? (
                                        <Modal
                                            show={composeStatus}
                                            onHide={() => setComposeStatus(false)}
                                            size="lg"
                                            backdrop="static"
                                        >
                                            <Modal.Header closeButton>
                                                <Modal.Title>Compose Email</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <ComposeEmail
                                                    currentTaskId={currentTaskId}
                                                    replyDropdown={composeStatus}
                                                    boardId={boardId}
                                                    selectedMail={selectedMail}
                                                    setComposeStatus={setComposeStatus}
                                                    attachmentPaths={attachmentsPath}
                                                    getTaskById={getTaskById}
                                                    childTaskData={childTaskData}
                                                    taskID={id}
                                                    originalEmail={originalEmail}
                                                    boardListId={boardListId}
                                                />
                                            </Modal.Body>
                                        </Modal>
                                    ) : (
                                        <Modal
                                            show={composeStatus}
                                            onHide={() => setComposeStatus(false)}
                                            size="sm"
                                            backdrop="static"
                                            centered
                                            className="p-4"
                                        >
                                            <Modal.Header className="p-3 pt-4" style={{ position: 'relative' }}>
                                                <Modal.Title className="fs-5">Please Select a Board</Modal.Title>
                                                <button
                                                    type="button"
                                                    className="btn-close"
                                                    aria-label="Close"
                                                    onClick={() => setComposeStatus(false)}
                                                    style={{ width: '1rem', height: '1rem', fontSize: '0.7rem' }}
                                                />
                                            </Modal.Header>
                                            <Modal.Body className="px-4 py-3">
                                                <p className="fs-6 mb-4">
                                                    Please select a board before composing an email.
                                                </p>
                                                <div className="text-end">
                                                    <button
                                                        className="btn btn-primary px-4 py-1 fs-6"
                                                        onClick={() => setComposeStatus(false)}
                                                    >
                                                        OK
                                                    </button>
                                                </div>
                                            </Modal.Body>
                                        </Modal>
                                    )}
                                </>
                            )}
                        </div>
                    )}
                    {selectedTab === 'WHATSAPP' && (
                        <div className="mt-4 rounded-[6px] w-full">
                            <WhatsApps
                                onSendMessage={handleWhatspp}
                                chatData={chatData}
                                profileId={profileId}
                                getChatById={getChatById}
                                selectedMail={selectedMail?.contactId}
                                chatContainerRef={chatContainerRef}
                                isSocketConnected={isSocketConnected}
                                sendingMessages={sendingMessages}
                                taskData={taskData}
                                onContactSelect={handleContactSelect}
                                selectedContact={selectedContact}
                                selectedGroupContacts={selectedGroupContacts}
                                selectedImages={selectedImages}
                                setSelectedImages={setSelectedImages}
                                loading={loading}
                            />
                        </div>
                    )}

                    {selectedTab == 'SENDER DETAILS' && (
                        <div className="overflow-y-scroll h-[calc(100vh-4rem)] mt-[1rem] gap-x-4">
                            <div className="mt-4 bg-white rounded-[6px] shadow-md p-4">
                                <h2 className="text-[18px] text-black font-bold mb-4">Attached Contacts</h2>

                                <div className="flex-1 w-full max-w-[20vw] border-b border-gray-200 mb-4">
                                    <Select
                                        closeMenuOnSelect={true}
                                        options={whatsappprofile}
                                        value={selectedprofiles}
                                        onChange={handleProfileChange}
                                        placeholder="Select Profile"
                                    />
                                </div>

                                <div className="flex border-b border-gray-200 mb-4">
                                    <button
                                        onClick={() => {
                                            setActiveTab('contact'),
                                                setSelectedGroupContacts(null),
                                                dispatch(whatsaapActiveTab('contact'));
                                        }}
                                        className={`px-4 py-2 font-medium ${activeTab === 'contact'
                                            ? 'border-b-2 border-blue-500 text-blue-600'
                                            : 'text-gray-500'
                                            }`}
                                    >
                                        Contact
                                    </button>
                                    <button
                                        onClick={() => {
                                            setActiveTab('group'), dispatch(whatsaapActiveTab('group'));
                                        }}
                                        className={`px-4 py-2 font-medium ${activeTab === 'group'
                                            ? 'border-b-2 border-blue-500 text-blue-600'
                                            : 'text-gray-500'
                                            }`}
                                    >
                                        Group Contact
                                    </button>
                                </div>
                                <div className="flex w-full max-w-[20vw] items-center justify-between mb-4">
                                    <div className="flex-1 ">
                                        {activeTab === 'contact' && (
                                            <div>
                                                <Select
                                                    closeMenuOnSelect={true}
                                                    options={contacts}
                                                    value={contacts?.filter((group) =>
                                                        selectedContactTaskData
                                                            ?.map((task) => task?.contactId)
                                                            .includes(group?.value),
                                                    )}
                                                    onChange={handleContactChange}
                                                    placeholder="Select Contact"
                                                />
                                            </div>
                                        )}
                                        {activeTab === 'group' && (
                                            <Select
                                                closeMenuOnSelect={true}
                                                options={groupContacts}
                                                value={groupContacts?.filter((group) =>
                                                    taskData?.map((task) => task?.contactId).includes(group?.value),
                                                )}
                                                onChange={handleGroupContactChange}
                                                placeholder="Select Group Contacts"
                                            />
                                        )}
                                    </div>
                                    {activeTab == 'contact' ? (
                                        <button
                                            onClick={() => {
                                                if (!selectedprofiles || !selectedprofiles.value) {
                                                    toast.error('Please select a profile first!');
                                                    return;
                                                }
                                                activeTab === 'contact'
                                                    ? setShowAddContactModal(true)
                                                    : setShowAddGroupModal(true);
                                            }}
                                            className="ml-3 bg-[#2d6ec7] hover:bg-[#1b4e8a] text-white p-2 rounded-full transition-colors duration-200 flex items-center justify-center"
                                            title={activeTab === 'contact' ? 'Add New Contact' : 'Create New Group'}
                                        >
                                            <MdAdd size={20} />
                                        </button>
                                    ) : null}
                                </div>
                            </div>
                            <div className="mt-4 bg-white rounded-[6px] shadow-md p-4">
                                <div className="">
                                    <h2 className="text-[18px] text-black font-bold mb-4">Traveller details</h2>
                                </div>
                                <div className="grid grid-cols-2 gap-4 input-force">
                                    <div>
                                        <label
                                            htmlFor="gender"
                                            className="block mb-[0.4rem] text-gray-600 text-sm font-i"
                                        >
                                            Gender
                                        </label>
                                        <select
                                            className="h-10 w-full input-border"
                                            value={gender}
                                            onChange={handlegenderChange}
                                        >
                                            <option value="male">Male</option>
                                            <option value="female">Female</option>
                                            <option value="other">Other</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label
                                            htmlFor="email"
                                            className="block mb-[0.4rem] text-gray-600 text-sm font-i"
                                        >
                                            Email
                                        </label>

                                        <input
                                            type="email"
                                            id="email"
                                            className="h-10 w-full border-r  text-gray-900 font-i focus:outline-none p-3 border-i input-border"
                                            value={email}
                                            onChange={handleEmailChange}
                                            disabled={isEmailappTask}
                                        />
                                    </div>
                                    <div>
                                        <label
                                            htmlFor="firstName"
                                            className="block mb-[0.4rem] text-gray-600 text-sm font-i"
                                        >
                                            First Name (as per Passport)
                                        </label>
                                        <input
                                            type="text"
                                            id="firstName"
                                            className="h-10 w-full border-r  text-gray-900 font-i focus:outline-none p-3 border-i input-border"
                                            value={firstName}
                                            onChange={handleFirstNameChange}
                                        />
                                    </div>
                                    <div>
                                        <label
                                            htmlFor="phone"
                                            className="block mb-[0.4rem] text-gray-600 text-sm font-i"
                                        >
                                            Phone
                                        </label>
                                        <input
                                            type="number"
                                            id="phone"
                                            className="h-10 w-full border-r  text-gray-900 font-i focus:outline-none p-3 border-i input-border"
                                            value={phone}
                                            onChange={handlePhoneChange}
                                            disabled={isWhatsappTask}
                                            onKeyDown={(e) => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                                        />
                                    </div>
                                    <div>
                                        <label
                                            htmlFor="lastName"
                                            className="block mb-[0.4rem] text-gray-600 text-sm font-i"
                                        >
                                            Last Name (as per Passport)
                                        </label>
                                        <input
                                            type="text"
                                            id="lastName"
                                            className="h-10 w-full border-r  text-gray-900 font-i focus:outline-none p-3 border-i input-border"
                                            value={lastName}
                                            onChange={handleLastNameChange}
                                        />
                                    </div>
                                    <div>
                                        <label
                                            htmlFor="nationality"
                                            className="block mb-[0.4rem] text-gray-600 text-sm font-i"
                                        >
                                            Nationality
                                        </label>
                                        <input
                                            type="text"
                                            id="nationality"
                                            className="h-10 w-full border-r  text-gray-900 font-i focus:outline-none p-3 border-i input-border"
                                            value={nationality}
                                            onChange={handleNationalityChange}
                                        />
                                    </div>
                                    <div>
                                        <label
                                            htmlFor="preExistingMedicalConditions"
                                            className="block mb-[0.4rem] text-gray-600 text-sm font-i"
                                        >
                                            Pre-existing medical conditions
                                        </label>
                                        <textarea
                                            id="preExistingMedicalConditions"
                                            rows={3}
                                            className=" w-full border-r  text-gray-900 font-i focus:outline-none p-3 border-i input-border"
                                            value={preExistingMedicalConditions}
                                            onChange={handlePreExistingMedicalConditionsChange}
                                        ></textarea>
                                    </div>
                                </div>
                                <button
                                    onClick={() =>
                                        handleSubmitTraveller('traveller', {
                                            label: selectedContact?.name,
                                            value: selectedContact?.id,
                                        })
                                    }
                                    className="bg-[#2d6ec7] hover:bg-[#2d6ec7] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline mt-4"
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    )}

                    {selectedTab == 'ATTACHEMENT' && (
                        <>
                            <div className="bg-white rounded-[6px] shadow-md p-4 mt-[15px]">
                                <div className="flex w-full max-w-[50rem] overflow-hidden border-b border-gray-300">
                                    <button
                                        className="flex-1 py-2 text-lg font-semibold transition-colors duration-200"
                                        style={{
                                            color: attachmentTab === 'ALL' ? '#01579b' : 'gray',
                                            borderBottom: `2px solid ${attachmentTab === 'ALL' ? '#01579b' : 'transparent'
                                                }`,
                                        }}
                                        onClick={() => setAttachmentTab('ALL')}
                                    >
                                        All
                                    </button>
                                    <button
                                        className="flex-1 py-2 text-lg font-semibold transition-colors duration-200"
                                        style={{
                                            color: attachmentTab === 'GMAIL' ? '#01579b' : 'gray',
                                            borderBottom: `2px solid ${attachmentTab === 'GMAIL' ? '#01579b' : 'transparent'
                                                }`,
                                        }}
                                        onClick={() => setAttachmentTab('GMAIL')}
                                    >
                                        GMAIL
                                    </button>

                                    <button
                                        className="flex-1 py-2 text-lg font-semibold transition-colors duration-200"
                                        style={{
                                            color: attachmentTab === 'WHATSAPP' ? '#01579b' : 'gray',
                                            borderBottom: `2px solid ${attachmentTab === 'WHATSAPP' ? '#01579b' : 'transparent'
                                                }`,
                                        }}
                                        onClick={() => setAttachmentTab('WHATSAPP')}
                                    >
                                        WHATSAPP
                                    </button>
                                    <button
                                        className="flex-1 py-2 text-lg font-semibold transition-colors duration-200"
                                        style={{
                                            color: attachmentTab === 'TASKATTACHMENT' ? '#01579b' : 'gray',
                                            borderBottom: `2px solid ${attachmentTab === 'TASKATTACHMENT' ? '#01579b' : 'transparent'
                                                }`,
                                        }}
                                        onClick={() => setAttachmentTab('TASKATTACHMENT')}
                                    >
                                        Task Attachment
                                    </button>
                                </div>
                                <div>
                                    {attachmentTab === 'ALL' && (
                                        <div className="mt-2 ">
                                            {allattachmentsPathData && allattachmentsPathData.length > 0 ? (
                                                <div
                                                    className="overflow-y-auto pr-2"
                                                    style={{ height: '100vh', marginTop: '10px' }}
                                                >
                                                    {allattachmentsPathData.map((path, idx) => {
                                                        const fullName = path.split('/').pop();
                                                        const fileName = fullName?.includes('_')
                                                            ? fullName.substring(fullName?.lastIndexOf('_') + 1)
                                                            : fullName;

                                                        const fileUrl = `${process.env.REACT_APP_IMAGE_URL}/${path}`;
                                                        const fileExt = fileName.split('.').pop().toLowerCase();

                                                        const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(
                                                            fileExt,
                                                        );
                                                        const fileIcons = {
                                                            pdf: (
                                                                <img
                                                                    src="https://cdn-icons-png.flaticon.com/128/4726/4726010.png"
                                                                    alt="PDF"
                                                                    style={{ width: 24, height: 28 }}
                                                                />
                                                            ),
                                                            doc: '📝',
                                                            docx: '📝',
                                                            jpg: '🖼️',
                                                            jpeg: '🖼️',
                                                            png: '🖼️',
                                                            default: '📎',
                                                        };

                                                        const icon = fileIcons[fileExt] || fileIcons.default;

                                                        return (
                                                            <div
                                                                key={idx}
                                                                className="flex items-center justify-between bg-white rounded-lg px-4 py-3 mb-3 border border-gray-200 shadow-sm hover:shadow transition w-full max-w-sm"
                                                            >
                                                                <div className="flex items-center gap-3 min-w-0">
                                                                    {isImage ? (
                                                                        <img
                                                                            src={fileUrl}
                                                                            alt={fileName}
                                                                            className="w-10 h-10 rounded-md object-cover border border-gray-300"
                                                                        />
                                                                    ) : (
                                                                        <div className="w-10 h-10 rounded-md flex items-center justify-center bg-gray-100 text-gray-500 border border-gray-300 text-lg">
                                                                            {icon}
                                                                        </div>
                                                                    )}
                                                                    <span
                                                                        className="truncate max-w-[140px] font-medium text-gray-800 text-sm"
                                                                        title={fileName}
                                                                    >
                                                                        {fileName}
                                                                    </span>
                                                                </div>
                                                                <a
                                                                    href={fileUrl}
                                                                    download={fileName}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="bg-[#2d6ec7] hover:bg-[#1b4e8a] text-white px-3 py-1 rounded text-xs font-semibold transition"
                                                                    style={{ textDecoration: 'none' }}
                                                                >
                                                                    Preview
                                                                </a>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            ) : (
                                                <span className="text-gray-500">No attachments</span>
                                            )}
                                        </div>
                                    )}
                                    {attachmentTab === 'GMAIL' && (
                                        <div className="mt-2">
                                            <div
                                                className="overflow-y-auto pr-2"
                                                style={{ height: '100vh', marginTop: '10px' }}
                                            >
                                                {allEmailAttachments && allEmailAttachments.length > 0 ? (
                                                    allEmailAttachments?.map((path, idx) => {
                                                        const fullName = path.split('/').pop();
                                                        const fileName = fullName?.includes('_')
                                                            ? fullName.substring(fullName?.lastIndexOf('_') + 1)
                                                            : fullName;

                                                        const fileUrl = `${process.env.REACT_APP_IMAGE_URL}/${path}`;
                                                        const fileExt = fileName.split('.').pop().toLowerCase();

                                                        const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(
                                                            fileExt,
                                                        );

                                                        const fileIcons = {
                                                            pdf: (
                                                                <img
                                                                    src="https://cdn-icons-png.flaticon.com/128/4726/4726010.png"
                                                                    alt="PDF"
                                                                    style={{ width: 24, height: 28 }}
                                                                />
                                                            ),
                                                            doc: '📝',
                                                            docx: '📝',
                                                            jpg: '🖼️',
                                                            jpeg: '🖼️',
                                                            png: '🖼️',
                                                            default: '📎',
                                                        };

                                                        const icon = fileIcons[fileExt] || fileIcons.default;

                                                        return (
                                                            <div
                                                                key={idx}
                                                                className="flex items-center justify-between bg-white rounded-lg px-4 py-3 mb-3 border border-gray-200 shadow-sm hover:shadow transition w-full max-w-sm"
                                                            >
                                                                <div className="flex items-center gap-3 min-w-0">
                                                                    {isImage ? (
                                                                        <img
                                                                            src={fileUrl}
                                                                            alt={fileName}
                                                                            className="w-10 h-10 rounded-md object-cover border border-gray-300"
                                                                        />
                                                                    ) : (
                                                                        <div className="w-10 h-10 rounded-md flex items-center justify-center bg-gray-100 text-gray-500 border border-gray-300 text-lg">
                                                                            {icon}
                                                                        </div>
                                                                    )}
                                                                    <span
                                                                        className="truncate max-w-[140px] font-medium text-gray-800 text-sm"
                                                                        title={fileName}
                                                                    >
                                                                        {fileName}
                                                                    </span>
                                                                </div>
                                                                <a
                                                                    href={fileUrl}
                                                                    download={fileName}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="bg-[#2d6ec7] hover:bg-[#1b4e8a] text-white px-3 py-1 rounded text-xs font-semibold transition"
                                                                    style={{ textDecoration: 'none' }}
                                                                >
                                                                    Preview
                                                                </a>
                                                            </div>
                                                        );
                                                    })
                                                ) : (
                                                    <span className="text-gray-500">No attachments</span>
                                                )}
                                            </div>
                                        </div>
                                    )}

                                    {attachmentTab === 'WHATSAPP' && (
                                        <div
                                            className="overflow-y-auto pr-2"
                                            style={{ height: '100vh', marginTop: '10px' }}
                                        >
                                            {chatData?.map((item, itemIdx) =>
                                                item.attachementPath && item.attachementPath.length > 0
                                                    ? item.attachementPath.map((path, idx) => {
                                                        const fullName = path.split('/').pop();
                                                        const fileName = fullName.includes('_')
                                                            ? fullName.substring(fullName.lastIndexOf('_') + 1)
                                                            : fullName;

                                                        const fileUrl = `${process.env.REACT_APP_IMAGE_URL}/${path}`;
                                                        const fileExt = fileName.split('.').pop().toLowerCase();

                                                        const isImage = [
                                                            'jpg',
                                                            'jpeg',
                                                            'png',
                                                            'gif',
                                                            'webp',
                                                        ].includes(fileExt);

                                                        const fileIcons = {
                                                            pdf: '📄',
                                                            doc: '📝',
                                                            docx: '📝',
                                                            default: '📎',
                                                        };

                                                        const icon = fileIcons[fileExt] || fileIcons.default;

                                                        return (
                                                            <div
                                                                key={`${itemIdx}-${idx}`}
                                                                className="flex items-center justify-between bg-white rounded-lg px-4 py-3 mb-3 border border-gray-200 shadow-sm hover:shadow transition w-full max-w-sm"
                                                            >
                                                                <div className="flex items-center gap-3 min-w-0">
                                                                    {isImage ? (
                                                                        <img
                                                                            src={fileUrl}
                                                                            alt={fileName}
                                                                            className="w-10 h-10 rounded-md object-cover border border-gray-300"
                                                                        />
                                                                    ) : (
                                                                        <div className="w-10 h-10 rounded-md flex items-center justify-center bg-gray-100 text-gray-500 border border-gray-300 text-lg">
                                                                            {icon}
                                                                        </div>
                                                                    )}
                                                                    <span
                                                                        className="truncate max-w-[140px] font-medium text-gray-800 text-sm"
                                                                        title={fileName}
                                                                    >
                                                                        {fileName}
                                                                    </span>
                                                                </div>
                                                                <a
                                                                    href={fileUrl}
                                                                    download={fileName}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    style={{ textDecoration: 'none' }}
                                                                    className="bg-[#2d6ec7] hover:bg-[#1b4e8a] text-white px-3 py-1 rounded text-xs font-semibold transition"
                                                                >
                                                                    Preview
                                                                </a>
                                                            </div>
                                                        );
                                                    })
                                                    : null,
                                            )}
                                        </div>
                                    )}

                                    {attachmentTab === 'TASKATTACHMENT' && (
                                        <>
                                            {showAllAttachment && showAllAttachment.length > 0 ? (
                                                <div
                                                    className="overflow-y-auto pr-2"
                                                    style={{ height: '100vh', marginTop: '10px' }}
                                                >
                                                    {showAllAttachment.map((file, idx) => {
                                                        const fileName = file.finalName;

                                                        const fileExt = fileName.split('.').pop().toLowerCase();

                                                        const fileUrl = `${process.env.REACT_APP_IMAGE_URL}/${fileName}`;

                                                        const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(fileExt);

                                                        const fileIcons = {
                                                            pdf: (
                                                                <img
                                                                    src="https://cdn-icons-png.flaticon.com/128/4726/4726010.png"
                                                                    alt="PDF"
                                                                    className="w-6 h-6"
                                                                />
                                                            ),
                                                            doc: '📝',
                                                            docx: '📝',
                                                            jpg: '🖼️',
                                                            jpeg: '🖼️',
                                                            png: '🖼️',
                                                            default: '📎',
                                                        };

                                                        const icon = fileIcons[fileExt] || fileIcons.default;

                                                        return (
                                                            <div
                                                                key={idx}
                                                                className="flex items-center justify-between bg-white rounded-lg px-4 py-3 mb-3 border border-gray-200 shadow-sm hover:shadow transition w-full max-w-sm"
                                                            >
                                                                <div className="flex items-center gap-3 min-w-0">
                                                                    {isImage ? (
                                                                        <img
                                                                            src={fileUrl}
                                                                            alt={fileName}
                                                                            className="w-10 h-10 rounded-md object-cover border border-gray-300"
                                                                        />
                                                                    ) : (
                                                                        <div className="w-10 h-10 rounded-md flex items-center justify-center bg-gray-100 text-gray-500 border border-gray-300 text-lg">
                                                                            {icon}
                                                                        </div>
                                                                    )}
                                                                    <span
                                                                        className="truncate max-w-[140px] font-medium text-gray-800 text-sm"
                                                                        title={fileName}
                                                                    >
                                                                        {fileName}
                                                                    </span>
                                                                </div>

                                                                <a
                                                                    href={fileUrl}
                                                                    download={fileName}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="bg-[#2d6ec7] hover:bg-[#1b4e8a] text-white px-3 py-1 rounded text-xs font-semibold transition"
                                                                    style={{ textDecoration: 'none' }}
                                                                >
                                                                    Preview
                                                                </a>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            ) : (
                                                <span className="text-gray-500">No Task Attachment</span>
                                            )}

                                        </>
                                    )}
                                </div>
                            </div>
                        </>
                    )}

                    {selectedTab === 'INTERNAL NOTES' && (
                        <>
                            <div className="notes-container">
                                <div className="note-input-box">
                                    <div className="note-entry-box">
                                        <div className="input-group">
                                            <label htmlFor="note-title">Title</label>
                                            <input
                                                id="note-title"
                                                type="text"
                                                value={newTitle}
                                                onChange={(e) => setNewTitle(e.target.value)}
                                                placeholder="Title"
                                                className="note-title-input"
                                                style={{
                                                    height: '40px',
                                                    borderRadius: '9px',
                                                    padding: '8px 12px',
                                                    border: '1px solid #ccc',
                                                    fontSize: '14px',
                                                    resize: 'none',
                                                    boxSizing: 'border-box',
                                                }}
                                            />
                                        </div>

                                        <div className="input-group">
                                            <label htmlFor="note-description">Description</label>

                                            <textarea
                                                id="note-description"
                                                value={newDescription}
                                                onChange={(e) => setNewDescription(e.target.value)}
                                                placeholder="Take a note... "
                                                className="note-title-input"
                                                style={{
                                                    height: '40px',
                                                    borderRadius: '9px',
                                                    padding: '8px 12px',
                                                    border: '1px solid #ccc',
                                                    fontSize: '14px',
                                                    resize: 'none',
                                                    boxSizing: 'border-box',
                                                }}
                                            />
                                        </div>

                                        <div
                                            style={{
                                                background: '#2d6ec7',
                                                color: 'white',
                                                padding: '8px',
                                                borderRadius: '5px',
                                                border: 'none',
                                                cursor: 'pointer',
                                                marginTop: '4px',
                                            }}
                                        >
                                            <button onClick={handleAddNote}>Add</button>
                                        </div>
                                    </div>

                                    <table className="notes-table">
                                        <thead>
                                            <tr>
                                                <th className="internotes-table-th">Note</th>
                                                <th className="internotes-table-th">Created By</th>
                                                <th className="internotes-table-th">Date</th>
                                                <th className="internotes-table-th">Description</th>

                                                <th className="internotes-table-th">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {notes.map((note) => (
                                                <tr key={note.id}>
                                                    <td>{note.notes || 'Untitled'}</td>
                                                    <td>{note?.User?.name || 'N/A'}</td>

                                                    <td>{new Date(note.createdAt).toLocaleDateString()}</td>
                                                    <td onClick={() => handleDescriptionClick(note.description)}>
                                                        <i className="fa fa-eye"></i> View
                                                    </td>

                                                    <td>
                                                        <button
                                                            onClick={() => deleteNote(note.id)}
                                                            title="Delete"
                                                            style={{ color: '#e12d39' }}
                                                        >
                                                            <i class="bi bi-trash"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div>
                                {showModal && (
                                    <div
                                        style={{
                                            position: 'fixed',
                                            top: 0,
                                            left: 0,
                                            width: '100%',
                                            height: '100%',
                                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            zIndex: 1000,
                                        }}
                                    >
                                        <div
                                            style={{
                                                background: '#fff',
                                                borderRadius: '10px',
                                                padding: '30px 20px',
                                                width: '90%',
                                                maxWidth: '500px',
                                                boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
                                                textAlign: 'left',
                                                position: 'relative',
                                            }}
                                        >
                                            <h2
                                                style={{
                                                    marginBottom: '15px',
                                                    fontSize: '20px',
                                                    fontWeight: '600',
                                                }}
                                            >
                                                Description
                                            </h2>

                                            <pre
                                                style={{
                                                    maxHeight: '300px',
                                                    overflowY: 'auto',
                                                    fontSize: '16px',
                                                    lineHeight: '1.5',
                                                    color: '#333',
                                                    whiteSpace: 'pre-wrap',
                                                    wordWrap: 'break-word',
                                                    backgroundColor: '#f9f9f9',
                                                    padding: '10px',
                                                    borderRadius: '4px',
                                                }}
                                            >
                                                {selectedDescription}
                                            </pre>

                                            <div style={{ textAlign: 'end' }}>
                                                <button
                                                    onClick={() => setShowModal(false)}
                                                    style={{
                                                        marginTop: '20px',
                                                        padding: '8px 16px',
                                                        backgroundColor: '#007bff',
                                                        color: '#fff',
                                                        border: 'none',
                                                        borderRadius: '4px',
                                                        cursor: 'pointer',
                                                        textAlign: 'end',
                                                    }}
                                                >
                                                    Close
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </>
                    )}
                </div>
            </div>

            <div className="w-[25%] max-w-[25%] h-[100vh] overflow-y-auto" style={{ scrollbarWidth: 'none' }}>
                <TaskData
                    taskItem={currentTask}
                    gmailMessageID={currentTask?.gmailMessageId}
                    updateTaskMail={updateTaskMail}
                    setBoardListId={setBoardListId}
                    getTaskMail={getTaskMail}
                    setCurrentTask={setCurrentTask}
                    setTaskDetailModal={setTaskDetailModal}
                    setComposeStatus={setComposeStatus}
                    threadData={threadData}
                    setSelectedEmailData={setSelectedEmailData}
                    selectedMail={selectedMail}
                    setSelectedMail={setSelectedMail}
                    selectedEmail={selectedEmail}
                    currentTaskId={currentTaskId}
                    setCurrentTaskId={setCurrentTaskId}
                    handlegetEmailDetails={handlegetEmailDetails}
                    getemailbyid={getemailbyid}
                    selectedEmailData={selectedEmailData}
                    childTaskData={childTaskData}
                    selectedItem={selectedItem}
                    setSelectedItem={setSelectedItem}
                    threadMergedArray={threadMergedArray}
                    setthreadMergedArray={setthreadMergedArray}
                    originalEmail={originalEmail}
                    setOriginalEmail={setOriginalEmail}
                    selectedUserId={selectedUserId}
                    selectedContact={selectedContact}
                    formattedBody={formattedBody}
                />
            </div>

            <AddContactModal
                showModal={showAddContactModal}
                handleClose={() => setShowAddContactModal(false)}
                sessionId={sessionId}
                onContactAdded={handleContactAdded}
            />
        </div>
    );
}

export default Whatsapp;
